// extracted by mini-css-extract-plugin
export default {"modalWindow":"modal_modalWindow__2j3C-","dialogTitle":"modal_dialogTitle__tc52K"};